import React, { Component } from "react";
import { Image, Grid, Header, Segment, Card } from "semantic-ui-react";
import BhajansList from "components/bhajans/BhajansList";
import { titleCase } from "util/stringUtil";
import { Container } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchAllNonLyrics } from "actions/nodes";
import "components/main/BrowseBhajans.css";

function Collection({ collection, bhajans }) {
  const { data, edges } = collection;

  const bhajanIds = edges.filter(e => e.name === "bhajan").map(e => e.nodeId);
  const foundBhajans = bhajanIds
    .map(bhajanId => bhajans.find(b => b.nodeId === bhajanId))
    .filter(b => !!b);

  return (
    <Segment raised padded style={{ marginBottom: "3em" }}>
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column width={4} textAlign="center">
            <Image
              src={data.artUrl}
              alt={data.name}
              bordered
              rounded
              size="medium"
            />
          </Grid.Column>
          <Grid.Column width={12}>
            <Header as="h1" style={{ marginBottom: "1em" }}>
              {titleCase(data.name)}
            </Header>
            <Card fluid>
              <Card.Content>
                <BhajansList bhajans={foundBhajans} numbered />
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

class BrowseCollections extends Component {
  componentDidMount() {
    this.props.fetchAllNonLyrics();
  }

  render() {
    const { graph } = this.props;

    if (!graph || !graph.collections) {
      return null;
    }

    return (
      <Container className="contentContainer" style={{ paddingTop: "2em" }}>
        {graph.collections.map((collection, idx) => (
          <Collection
            key={collection.nodeId || idx}
            collection={collection}
            bhajans={graph.bhajans}
          />
        ))}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ fetchAllNonLyrics }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(BrowseCollections);
